<template>
  <svg
    id="chart"
    viewBox="0 0 800 779"
    preserveAspectRatio="xMidYMid meet"
    pointer-events="auto"
    width="300px"
    @click="seleccionarTotesLesRegions"
  >
    <g class="regions">
      <path
        id="barcelona-ciutat"
        title="Barcelona"
        class="land"
        d="M 504.41 519.64 486.27 488.83 513.59 471.55 523.85 490.04 504.41 519.64 Z"
        stroke-width="1.8"
        stroke-opacity="0"
        :fill="
          getFillColor(
            getPercentatge('barcelona-ciutat', pregunta, liniaAssistencial),
            pregunta
          )
        "
        stroke="rgb(0, 123, 255)"
        pointer-events="all"
        style="cursor: pointer;"
        @mouseover="getInfo"
        @click="actualitzarRegioSanitaria('barcelona-ciutat')"
      >
        <title>Regió Sanitària {{ title }}</title>
      </path>
      <text
        font-size="50"
        x="580"
        y="510"
        text-anchor="middle"
        dominant-baseline="middle"
        fill="black"
        pointer-events="none"
      >
        {{ getPercentatge("barcelona-ciutat", pregunta, liniaAssistencial) }}
      </text>
      <path
        id="penedes"
        title="Penedès"
        class="land"
        d="M 338.9 567.24 323.92 530.63 345.8 519.57 326.76 474.85 298.18 481.65 269.85 440.92 272.24 433.97 318.02 438.81 307.68 420.06 329.91 412.8 322.75 399.44 371.87 393.78 393.81 418.36 430.47 457.56 411.95 450.07 419.23 477.36 440.28 509.4 427.73 524.28 445.56 540.58 385.07 559.1 338.9 567.24 Z"
        stroke-width="1.8"
        stroke-opacity="0"
        :fill="
          getFillColor(
            getPercentatge('penedes', pregunta, liniaAssistencial),
            pregunta
          )
        "
        stroke="rgb(0, 123, 255)"
        pointer-events="all"
        style="cursor: pointer;"
        @mouseover="getInfo"
        @click="actualitzarRegioSanitaria('penedes')"
      >
        <title>Regió Sanitària {{ title }}</title>
      </path>

      <text
        font-size="50"
        x="400"
        y="500"
        text-anchor="middle"
        dominant-baseline="middle"
        fill="black"
        pointer-events="none"
      >
        {{ getPercentatge("penedes", pregunta, liniaAssistencial) }}
      </text>
      <path
        id="catalunya-central"
        title="Catalunya Central"
        class="land"
        d="M 447.31 436.42 393.81 418.36 371.87 393.78 322.75 399.44 319.42 356.85 299.05 347.75 304.59 326.87 292.73 304.94 310.68 291.47 310.37 242.21 332.38 243.63 358.98 222.33 374.11 225.67 393.35 200.65 446.1 186.12 459.04 189.9 487.22 198.54 476.76 209.89 483.77 235.96 470.5 244.1 504.91 250.72 556.24 248.93 575.02 274.53 592.08 275.35 587.55 317.93 572.24 359.93 559.08 370.86 534.72 361.83 533.3 384.18 476.67 388.14 447.31 436.42 Z"
        stroke-width="1.8"
        stroke-opacity="0"
        :fill="
          getFillColor(
            getPercentatge('catalunya-central', pregunta, liniaAssistencial),
            pregunta
          )
        "
        stroke="rgb(0, 123, 255)"
        pointer-events="all"
        style="cursor: pointer;"
        @mouseover="getInfo"
        @click="actualitzarRegioSanitaria('catalunya-central')"
      >
        <title>Regió Sanitària {{ title }}</title>
      </path>
      <text
        font-size="50"
        x="440"
        y="310"
        text-anchor="middle"
        dominant-baseline="middle"
        fill="black"
        pointer-events="none"
      >
        {{ getPercentatge("catalunya-central", pregunta, liniaAssistencial) }}
      </text>
      <path
        id="alt-pirineu-aran"
        title="Alt Pirineu i Aran"
        class="land"
        d="M 292.73 304.94 281.83 310.92 279.97 269.13 256.51 250.48 238.16 277.85 201.07 281.75 162.43 274.89 142.03 262.26 166.89 171.52 149.17 129.14 168.35 84.56 153.94 81.13 141.01 32.65 156.07 1 253.4 33.32 267.01 54.52 313.99 51.89 327.41 73.5 339.97 122.2 333.65 144.93 360.23 148.28 387.6 128.47 422.72 130.13 449.81 145.15 474.17 178.43 459.04 189.9 446.1 186.12 393.35 200.65 374.11 225.67 358.98 222.33 332.38 243.63 310.37 242.21 310.68 291.47 292.73 304.94 Z"
        stroke-width="1.8"
        stroke-opacity="0"
        :fill="
          getFillColor(
            getPercentatge('alt-pirineu-aran', pregunta, liniaAssistencial),
            pregunta
          )
        "
        stroke="rgb(0, 123, 255)"
        pointer-events="all"
        style="cursor: pointer;"
        @mouseover="getInfo"
        @click="actualitzarRegioSanitaria('alt-pirineu-aran')"
      >
        <title>Regió Sanitària {{ title }}</title>
      </path>
      <text
        font-size="50"
        x="270"
        y="150"
        text-anchor="middle"
        dominant-baseline="middle"
        fill="black"
        pointer-events="none"
      >
        {{ getPercentatge("alt-pirineu-aran", pregunta, liniaAssistencial) }}
      </text>
      <path
        id="metropolita-nord"
        title="Metropolitana Nord"
        class="land"
        d="M 486.27 488.83 484.25 487.53 481.53 481.99 454.48 469.57 447.31 436.42 476.67 388.14 533.3 384.18 534.72 361.83 559.08 370.86 572.24 359.93 617.05 385.54 619.49 403.15 601.52 414.73 610.11 434.05 539.4 471.06 523.85 490.04 513.59 471.55 486.27 488.83 Z"
        stroke-width="1.8"
        stroke-opacity="0"
        :fill="
          getFillColor(
            getPercentatge('metropolita-nord', pregunta, liniaAssistencial),
            pregunta
          )
        "
        stroke="rgb(0, 123, 255)"
        pointer-events="all"
        style="cursor: pointer;"
        @mouseover="getInfo"
        @click="actualitzarRegioSanitaria('metropolita-nord')"
      >
        <title>Regió d'Emergències {{ title }}</title>
      </path>
      <text
        font-size="50"
        x="550"
        y="430"
        text-anchor="middle"
        dominant-baseline="middle"
        fill="black"
        pointer-events="none"
      >
        {{ getPercentatge("metropolita-nord", pregunta, liniaAssistencial) }}
      </text>
      <path
        id="camp-tarragona"
        class="land"
        title="Camp de Tarragona"
        d="M 168.5 512.39 206.78 503.94 235.41 469.73 261.71 460.82 269.85 440.92 298.18 481.65 326.76 474.85 345.8 519.57 323.92 530.63 338.9 567.24 204.95 612.65 176.62 643.07 156.21 621.87 167.03 599.05 142.71 584.24 128.6 558.51 135.94 538.61 168.26 528.42 168.5 512.39 Z"
        stroke-width="1.8"
        stroke-opacity="0"
        :fill="
          getFillColor(
            getPercentatge('camp-tarragona', pregunta, liniaAssistencial),
            pregunta
          )
        "
        stroke="rgb(0, 123, 255)"
        pointer-events="all"
        style="cursor: pointer;"
        @mouseover="getInfo"
        @click="actualitzarRegioSanitaria('camp-tarragona')"
      >
        <title>Regió Sanitària {{ title }}</title>
      </path>
      <text
        font-size="50"
        x="250"
        y="550"
        text-anchor="middle"
        dominant-baseline="middle"
        fill="black"
        pointer-events="none"
      >
        {{ getPercentatge("camp-tarragona", pregunta, liniaAssistencial) }}
      </text>
      <path
        id="girona"
        class="land"
        title="Girona"
        d="M 572.24 359.93 587.55 317.93 592.08 275.35 575.02 274.53 556.24 248.93 504.91 250.72 470.5 244.1 483.77 235.96 476.76 209.89 487.22 198.54 459.04 189.9 474.17 178.43 502.18 156.95 533.88 148.53 572.68 164.45 589.49 181.89 636.89 181.27 631.67 165.85 667.52 156.02 677.49 142.47 726.93 137.76 737.99 153.61 757.36 150.17 757.23 175.41 796.56 188.88 786.02 211.04 759.66 207.49 744.51 227.54 747.62 252.47 769.56 272.44 774.13 305.28 767.43 331.39 743.19 346.47 725.03 371.12 661.71 411.42 610.11 434.05 601.52 414.73 619.49 403.15 617.05 385.54 572.24 359.93 Z"
        stroke-width="1.8"
        stroke-opacity="0"
        :fill="
          getFillColor(
            getPercentatge('girona', pregunta, liniaAssistencial),
            pregunta
          )
        "
        stroke="rgb(0, 123, 255)"
        pointer-events="all"
        style="cursor: pointer;"
        @mouseover="getInfo"
        @click="actualitzarRegioSanitaria('girona')"
      >
        <title>Regió Sanitària {{ title }}</title>
      </path>
      <text
        font-size="50"
        x="670"
        y="250"
        text-anchor="middle"
        dominant-baseline="middle"
        fill="black"
        pointer-events="none"
      >
        {{ getPercentatge("girona", pregunta, liniaAssistencial) }}
      </text>

      <path
        id="lleida"
        class="land"
        title="Lleida"
        d="M 60.96 525.58 45.64 486.54 78.96 438.35 74.98 418.18 55.22 418.46 50.7 391.01 69.27 366.69 121.9 329.99 111.23 307.08 142.03 262.26 162.43 274.89 201.07 281.75 238.16 277.85 256.51 250.48 279.97 269.13 281.83 310.92 292.73 304.94 304.59 326.87 299.05 347.75 319.42 356.85 322.75 399.44 329.91 412.8 307.68 420.06 318.02 438.81 272.24 433.97 269.85 440.92 261.71 460.82 235.41 469.73 206.78 503.94 168.5 512.39 118.25 523.16 80.56 507.33 60.96 525.58 Z"
        stroke-width="1.8"
        stroke-opacity="0"
        :fill="
          getFillColor(
            getPercentatge('lleida', pregunta, liniaAssistencial),
            pregunta
          )
        "
        stroke="rgb(0, 123, 255)"
        pointer-events="all"
        style="cursor: pointer;"
        @mouseover="getInfo"
        @click="actualitzarRegioSanitaria('lleida')"
      >
        <title>Regió Sanitària {{ title }}</title>
      </path>
      <text
        font-size="50"
        x="200"
        y="370"
        text-anchor="middle"
        dominant-baseline="middle"
        fill="black"
        pointer-events="none"
      >
        {{ getPercentatge("lleida", pregunta, liniaAssistencial) }}
      </text>
      <path
        id="metropolita-sud"
        class="land"
        title="Metropolitana Sud"
        d="M 445.56 540.58 427.73 524.28 440.28 509.4 419.23 477.36 411.95 450.07 430.47 457.56 393.81 418.36 447.31 436.42 454.48 469.57 481.53 481.99 484.25 487.53 486.27 488.83 504.41 519.64 501.95 527.49 445.56 540.58 Z"
        stroke-width="1.8"
        stroke-opacity="0"
        :fill="
          getFillColor(
            getPercentatge('metropolita-sud', pregunta, liniaAssistencial),
            pregunta
          )
        "
        stroke="rgb(0, 123, 255)"
        pointer-events="all"
        style="cursor: pointer;"
        @mouseover="getInfo"
        @click="actualitzarRegioSanitaria('metropolita-sud')"
      >
        <title>Regió d'Emergències {{ title }}</title>
      </path>
      <text
        font-size="50"
        x="490"
        y="560"
        text-anchor="middle"
        dominant-baseline="middle"
        fill="black"
        pointer-events="none"
      >
        {{ getPercentatge("metropolita-sud", pregunta, liniaAssistencial) }}
      </text>
      <path
        id="terres-ebre"
        class="land"
        title="Terres de l'Ebre"
        d="M 60.96 525.58 80.56 507.33 118.25 523.16 168.5 512.39 168.26 528.42 135.94 538.61 128.6 558.51 142.71 584.24 167.03 599.05 156.21 621.87 176.62 643.07 135.77 685.71 176.35 709.4 175.68 724.45 149.19 740.17 109.21 745.66 86.2 778 55.01 749.16 27.48 740.67 31.36 721.35 1 705.54 29.47 676.99 19.94 655.92 34.45 628.02 12.55 588.77 16.36 571.29 38.74 564.06 60.96 525.58 Z"
        stroke-width="1.8"
        stroke-opacity="0"
        :fill="
          getFillColor(
            getPercentatge('terres-ebre', pregunta, liniaAssistencial),
            pregunta
          )
        "
        stroke="rgb(0, 123, 255)"
        pointer-events="all"
        style="cursor: pointer;"
        @mouseover="getInfo"
        @click="actualitzarRegioSanitaria('terres-ebre')"
      >
        <title>Regió Sanitària {{ title }}</title>
      </path>
      <text
        font-size="50"
        x="100"
        y="650"
        text-anchor="middle"
        dominant-baseline="middle"
        fill="black"
        pointer-events="none"
      >
        {{ getPercentatge("terres-ebre", pregunta, liniaAssistencial) }}
      </text>
    </g>
    <g class="state-borders" fill="none" stroke-width="1.5" />

    <g class="circles" />
  </svg>
</template>

<script>
export default {
  data() {
    return {
      title: "",
      id: "",
      regioSeleccionada: "",
      sectorSeleccionat: null,
    };
  },
  props: {
    data: {
      type: Array,
    },
    pregunta: {
      type: Number,
    },
    regioSanitariaSeleccionada: {
      type: String,
    },
    liniaAssistencial: {
      type: String,
    },
  },
  methods: {
    getInfo(e) {
      this.title = e.target.getAttribute("title");
    },
    getPercentatge(regio, pregunta, liniaAssistencial) {
      // Troba les dades de la regio en el prop 'data'
      const regionData = this.data.find(
        (item) => item.nomRegioSanitaria === regio
      );
      //Si filtrem per linia assistencial el index de pregunta no coincideix amb el id de la pregunta
      switch (liniaAssistencial) {
        case "HOS":
          if (pregunta === 7) {
            pregunta = 11;
          } else if(pregunta === 8) {
            pregunta = 12;
          }
          break;
        case "URG":
          if (pregunta === 7) {
            pregunta = 9;
          } else if(pregunta === 8) {
            pregunta = 10;
          }
          break;
        case "AEA":
          if (pregunta === 7) {
            pregunta = 13;
          } else if(pregunta === 8) {
            pregunta = 14;
          }
          break;
        default:
          break;
      }
      //Si les preguntes son de satisfaccio no s'ha d'afegir el char %
      if (regionData && regionData.preguntaPercentatge) {
        if (pregunta === 15 || pregunta === 16) {
          return regionData.preguntaPercentatge[pregunta] || 0;
        } else {
          return regionData.preguntaPercentatge[pregunta] + "%" || 0; 
        }
      } else {
        return "";
      }
    },
    getFillColor(percent, pregunta) {
      //Agafem el percentatge sense el char % per poder saber quin color s'haura d'aplicar
      if (percent !== null && percent !== undefined) {
        if (percent.includes && percent.includes("%")) {
          percent = parseFloat(percent.replace("%", ""));
        } else {
          percent = parseFloat(percent);
        }
      }
      if (pregunta === 15 || pregunta === 16) {
        if (percent >= 8) {
          return "#00ab84";
        } else {
          return "#f4364c";
        }
      } else {
        if (percent >= 90) {
          return "#00ab84";
        } else if (percent < 90 && percent > 75) {
          return "#e1d906";
        } else if (percent === null || percent === "") {
          return "burlywood";
        } else {
          return "#f4364c";
        }
      }
    },
    actualitzarRegioSanitaria(regio) {
      //Logica per a que es vegui seleccionada una regio 
      if (regio !== null && regio !== "") {
        // Elimina la clase 'selected' de qualsevol altre element de path seleccionat anteriorment
        const selectedPathRegio = document.querySelector(".selected");
        if (selectedPathRegio) {
          selectedPathRegio.classList.remove("selected");
        }
        const selectedPathSector = document.querySelector(".selected-sector");
        if (selectedPathSector) {
          selectedPathSector.classList.remove("selected-sector");
        }
        const selectedPathSectorBarcelona = document.querySelector(
          ".selected-sector-barcelona"
        );
        if (selectedPathSectorBarcelona) {
          selectedPathSectorBarcelona.classList.remove(
            "selected-sector-barcelona"
          );
        }
        // Agrega la clase 'selected' al patch actual seleccionat
        const currentPath = document.getElementById(regio);
        if (currentPath) {
          currentPath.classList.add("selected");
        }

        // Agrega la clase 'non-selected' a tots els paths no seleccionats
        const allPathsRegio = document.querySelectorAll(".land");
        allPathsRegio.forEach((path) => {
          if (path.id !== regio) {
            path.classList.add("non-selected");
          } else {
            path.classList.remove("non-selected");
          }
        });
        const allPathsSector = document.querySelectorAll(".land-sector");
        allPathsSector.forEach((path) => {
          path.classList.remove("non-selected-sector");
        });
      }

      this.regioSeleccionada = regio;
      this.sectorSeleccionat = null;
      this.$emit("sector-sanitari", this.sectorSeleccionat);
      this.$emit("regio-sanitaria", this.regioSeleccionada);
    },
    seleccionarTotesLesRegions(event) {
      // Verifica si es fa clic fora de les regions
      if (!event.target.closest("path")) {
        // Reinicia la regio seleccionada i aplica els estils corresponents
        this.regioSeleccionada = "";
        this.$emit("regio-sanitaria", this.regioSeleccionada);
        const selectedPath = document.querySelector(".selected");
        if (selectedPath) {
          selectedPath.classList.remove("selected");
        }
        const allPaths = document.querySelectorAll(".land");
        allPaths.forEach((path) => {
          path.classList.remove("non-selected");
        });
      }
    },
  },
  mounted() {
    this.actualitzarRegioSanitaria(this.regioSanitariaSeleccionada);
  },
};
</script>
<style scoped>
path {
  cursor: pointer;
  -webkit-transition: all 150ms;
  -moz-transition: all 150ms;
  -o-transition: all 150ms;
  transition: all 150ms;
}

path:hover {
  opacity: 0.85;
}

.land {
  fill-opacity: 1;
  stroke: white;
  stroke-opacity: 1;
  stroke-width: 0.5;
}

.selected {
  stroke: #000; /* Cambia el color del borde para resaltar */
  stroke-width: 2; /* Ajusta el ancho del borde para resaltar */
}

.non-selected {
  opacity: 0.5; /* Cambia la opacidad para los caminos no seleccionados */
}
</style>
